import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import fullrefund_img from '../../asset/img/fullrefund_ant_img.svg';

import SlideDialogV from './SlideDialogV';
import AlertDialog from './AlertDialog';
import { closeSlideUp, closeAlert } from '../../features/common/dialogSlice';
import {
  deleteDependentsInfo,
  confirmDelete as dependentsConfirmDelete,
  getPreviousDependentsInfo,
} from '../../features/dependents/dependentsSlice';
import {
  deletePreviousEmployment,
  confirmDelete as previousEmploymentConfirmDelete,
} from '../../features/previousEmployment/previousSlice';
import { deleteDonationInfo } from '../../features/deductions/donations/doncationSlice';
import {
  deleteHousingFunds2,
  deleteHousingFunds3,
} from '../../features/deductions/housingFunds/housingFundsSlice';
import { deleteOtherDeductionsData } from '../../features/deductions/otherDeductions/otherDeductionsSlice';
import { deletePDFAll } from '../../features/eDocuments/eDocumentsSlice';
import { deleteEvidenceDocuments } from '../../features/evidenceDocuments/evidenceDocumentsSlice';
import { deleteMedicalDetail } from '../../features/deductions/medicalExpenses/medicalSlice';
import Typography from './Typography';
import { setCloseDialog } from '../../features/common/commonSlice';

const GlobalDialog = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { slideUp, alert } = useSelector(state => state.dialog);
  const { myInfo } = useSelector(state => state.myInfo);
  const { t: tCommon } = useTranslation('common');

  //첫번째 버튼 눌렀을때
  const handleSlideUpAction = (actionType, actionPayload, slice, index) => {
    switch (actionType) {
      case 'DELETE':
        const deleteActions = {
          previousEmployment: deletePreviousEmployment,
          dependents: deleteDependentsInfo,
          medical: deleteMedicalDetail, //의료비
          donation: deleteDonationInfo, //기부금
          housingFunds: deleteHousingFunds2, //주택마련저축
          housingFunds3: deleteHousingFunds3, //월세액
          otherDeductions: deleteOtherDeductionsData, //투자조합
          eDocuments: deletePDFAll, //전자문서 파일 초기화
          evidenceDocuments: deleteEvidenceDocuments, //증빙서류 파일 삭제
        };
        const deleteAction = deleteActions[slice];
        dispatch(deleteAction(actionPayload));
        break;

      case 'AUTO_SAVE':
        navigate('/');
        break;

      case 'GET_PREVIOUS_DEPENDENTS':
        const param = index === 1 ? { htmBoyangFlag: '2' } : {};
        console.log('param >>', param);
        dispatch(getPreviousDependentsInfo(param));
        break;

      case 'FULL_REFUND':
        navigate('/resultQuery');
        break;

      default:
        break;
    }
  };

  const handleAlertAction = (actionType, actionPayload, slice) => {
    if (actionType === 'CANCEL') {
      switch (slice) {
        case 'previousEmployment':
          // dispatch(previousEmploymentConfirmDelete(actionPayload));
          break;
        case 'dependents':
          // dispatch(dependentsConfirmDelete(actionPayload));
          break;
        case 'findPassword':
          navigate('/login');
          break;
        default:
          break;
      }
    }
  };

  const handleButtonClick = async (button, dialogType, index) => {
    const { actionType, actionPayload, slice } = dialogType === 'slideUp' ? slideUp : alert;

    if (dialogType === 'slideUp') {
      if (index === 0 && actionType === 'CANCEL') {
        dispatch(setCloseDialog(true));
      } else if (index === 0 && actionType) {
        handleSlideUpAction(actionType, actionPayload, slice);
      }
    }

    // 두 번째 버튼은 기본 동작을 함
    if (index === 1) {
      //자동로그인은 메인으로
      if (actionType === 'AUTO_SAVE') {
        navigate('/');
      }
      // 기본 동작: 아무 것도 하지 않음
      if (actionType === 'GET_PREVIOUS_DEPENDENTS') {
        handleSlideUpAction(actionType, actionPayload, slice, index);
      }
    }

    // 버튼의 actionType 처리
    if (button.actionType === 'PASS_TO_LOGIN') {
      dialogType === 'alert' ? dispatch(closeAlert()) : dispatch(closeSlideUp());
      navigate('/login');
      return;
    }

    dialogType === 'alert' ? dispatch(closeAlert()) : dispatch(closeSlideUp());
  };

  const processButtons = (buttons, dialogType) => {
    return buttons?.map((button, index) => ({
      ...button,
      onClick: () => handleButtonClick(button, dialogType, index),
    }));
  };

  //전액환급 대상자
  const FullRefundDialog = () => {
    return (
      <div
        className="displayFlexColumn"
        style={{ gap: '30px', alignItems: 'center', paddingBottom: '30px' }}>
        <img src={fullrefund_img} alt={tCommon('fullRefundDialog.title')} />
        <div className="displayFlexColumn" style={{ gap: '8px', alignItems: 'center' }}>
          <Typography className="subtitleBold">{tCommon('fullRefundDialog.title')}</Typography>
          <Typography>
            {myInfo.htmInsaPerNm}
            {tCommon('fullRefundDialog.description')}
          </Typography>
        </div>
      </div>
    );
  };

  return (
    <>
      <SlideDialogV
        isOpen={slideUp.isOpen}
        onClose={() => dispatch(closeSlideUp())}
        title={slideUp.title}
        description={slideUp.description}
        buttons={processButtons(slideUp.buttons, 'slideUp')}
        buttonStyle={slideUp.buttonStyle}
        innertComponent={slideUp.slice == 'fullRefund' ? FullRefundDialog() : null}
      />
      <AlertDialog
        isOpen={alert.isOpen}
        onClose={() => dispatch(closeAlert())}
        title={alert.title}
        description={alert.description}
        buttons={processButtons(alert.buttons, 'alert')}
        buttonStyle={alert.buttonStyle}
      />
    </>
  );
};

export default GlobalDialog;
